"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _utils = require("../utils");

var _default = {
  depth: 1,
  rootId: '',
  'exact-active-match': true,
  filterMode: _utils.FILTER_MODES.exclude
};
exports["default"] = _default;